var map = {
	"./01-venture-connect-fireside.jpg": 5955,
	"./02-venture-connect-audience.jpg": 9989,
	"./03-venture-connect-crowd.jpg": 7465,
	"./04-venture-connect-networking.jpg": 4827,
	"./05-venture-connect-group.jpg": 2717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3391;